import { createReducer } from '@reduxjs/toolkit';
import { acceptTermsAndConditions, acceptTermsAndConditionsRejected, acceptTermsAndConditionsResolved, setUserContext, } from '@innovyze/stylovyze/lib/actions/userContext.actions';
import { InnovyzeRole } from '@innovyze/stylovyze/lib/utils/InnovyzeRole';
export const initialState = {
    defaultSite: '',
    innovyzeRole: InnovyzeRole.READ_ONLY,
    id: '',
    email: '',
    name: '',
    entitlements: [],
    termsAndConditions: {
        status: 'idle',
    },
};
const reducer = {
    [setUserContext.toString()]: (state, action) => ({
        ...state,
        ...action.payload,
    }),
    [acceptTermsAndConditions.toString()]: state => {
        return { ...state, termsAndConditions: { status: 'loading' } };
    },
    [acceptTermsAndConditionsResolved.toString()]: (state, action) => {
        return {
            ...state,
            termsAndConditions: { ...action.payload, status: 'resolved' },
        };
    },
    [acceptTermsAndConditionsRejected.toString()]: state => {
        return { ...state, termsAndConditions: { status: 'rejected' } };
    },
};
export default createReducer(initialState, reducer);
